// extracted by mini-css-extract-plugin
export var arrows = "_5a-5";
export var decrementer = "_5a-9";
export var disabled = "_5a-3";
export var error = "_5a-1";
export var hiddenText = "_5a-a";
export var incrementer = "_5a-8";
export var input = "_5a-7";
export var inputWrapper = "_5a-0";
export var leadingIcon = "_5a-b";
export var readonly = "_5a-2";
export var regular = "_5a-6";
export var small = "_5a-4";